import { Injectable, Signal, WritableSignal, computed, inject, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { UnleashClient } from 'unleash-proxy-client';

import { environment } from '../../../environments/environment';
// @ts-ignore
import toggle from '../../../toggle.json';

@Injectable({
  providedIn: 'root'
})
export class UnleashProxyService {
  private unleashClient = inject(UnleashClient);
  private flags = new Map<string, WritableSignal<boolean>>();
  private defaultToggle: { name: string; description: string; enabled: boolean }[] = toggle;
  updateTrigger$ = new Subject<void>();
  private isStarted = false;

  constructor() {
    this.unleashClient.on('update', () => {
      this.sync();
      this.updateTrigger$.next();
    });
  }

  start() {
    if (this.isStarted) return;
    this.isStarted = true;
    this.unleashClient.start();
  }

  stop() {
    if (!this.isStarted) return;
    this.isStarted = false;
    this.unleashClient.stop();
  }

  isEnabledToggle(name: string): boolean {
    if (this.unleashClient.getAllToggles().length > 0) {
      return this.unleashClient.isEnabled(name);
    }

    return this.defaultToggle.find(f => f.name === name)?.enabled ?? false;
  }

  isEnabled$(names: string[]): Signal<boolean> {
    names.forEach(name => {
      if (!this.flags.has(name)) {
        const initial = this.isEnabledToggle(name);
        this.flags.set(name, signal<boolean>(initial));
      }
    });

    return computed(() => names.some(name => this.flags.get(name)?.() === true));
  }

  isEnabled(names: string[]): boolean {
    return names.some(name => this.isEnabledToggle(name));
  }

  private sync() {
    this.flags.forEach((sig, name) => {
      sig.set(this.unleashClient.isEnabled(name));
    });
  }
}

export function unleashFactory() {
  return new UnleashClient({
    url: environment.unleashUrl,
    clientKey: environment.unleashClientKey,
    appName: environment.unleashAppName,
    environment: environment.unleashEnvironment,
    customHeaders: environment.unleashCustomHeaders,
    refreshInterval: environment.unleashRefreshInterval
  });
}
